import React from 'react';
import Hotitemcard from './Hotitemcard';
import '../../styles/HotAccessories.css';


const Smartdevice = ({hotAccessoriesCover,hotAccessories}) => {
    console.log("smart Device",hotAccessories);
    console.log("smart device",hotAccessoriesCover)
    return (
        <>
        <div className="HotAccessories">
        <div>
            <img src={hotAccessoriesCover['smartDevice']} alt={`${'index'} offer`}></img>
        </div>    

        <div>
          {
              hotAccessories['smartDevice'].map((item,index)=>{
                  return(
                      <Hotitemcard key={item.image} name={item.name} prize={item.price} image={item.image} index={index}></Hotitemcard>
                  )
              })
          }
        </div>

   </div>
</>
    )
}

export default Smartdevice
